/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Appraisal
 *
 * 2 = CheckIn
 */
export enum AppraisalType {
  Appraisal = 1,
  CheckIn = 2,
}
